import Logger from 'nightingale';
import { runSync } from '../utils/exec';

const logger = new Logger('app:commands:system');

export const ntpUpdate = (): void => {
  logger.info('ntp update');
  runSync('./system.sh', ['ntpUpdate']);
};
